<script setup>
// Payment-system marks shown to the customer (SBP + MIR). Text-mark badges
// in the systems' recognized colors; swap the inner content for official
// brand SVGs if the operator supplies them.
</script>

<template>
  <div
    class="pbadges"
    aria-label="SBP, MIR"
  >
    <span
      class="pbadges__badge pbadges__badge--sbp"
      title="Система быстрых платежей"
    >СБП</span>
    <span
      class="pbadges__badge pbadges__badge--mir"
      title="МИР"
    >МИР</span>
  </div>
</template>

<style scoped>
.pbadges { display: inline-flex; gap: 0.5rem; align-items: center; }
.pbadges__badge {
  display: inline-flex; align-items: center; padding: 0.25rem 0.7rem;
  border-radius: 0.45rem; font-weight: 800; font-size: 0.8rem; letter-spacing: 0.02em;
  border: 1px solid var(--line); background: var(--surface); color: var(--ink);
}
.pbadges__badge--sbp { background: linear-gradient(135deg, #5B57A2 0%, #963A8E 45%, #FAB718 100%); color: #fff; border-color: transparent; }
.pbadges__badge--mir { background: #0F754E; color: #fff; border-color: transparent; }
</style>
